/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * This file contains the invitation page component
 * ---------------------------------------------------------------------------------
 */

/*
 * ----------------------------------------------------------------------------------
 * Imports - External
 * ----------------------------------------------------------------------------------
 */

/**
 * Required to use React components.
 */
import { TileInstitutionData } from '@/api/dtos';
import bg from '@/assets/img/tile-bg.png';
import TileDataContext from '@/contexts/Tiles/TileDataContext';
import { Box, Grid, GridProps, Paper, styled } from '@mui/material';
import * as React from 'react';
import { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import { ITrial } from '../../TrialsArea';
import ListOfContents from './ListOfContents';
import TileHeader from './TileHeader';


/*
 * ----------------------------------------------------------------------------------
 * Imports - Internal
 * ----------------------------------------------------------------------------------
 */


/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */


/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */

export const FavouriteTile = styled(Paper)(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch'
}))

export const TileBackground = styled(Box)(({ theme }) => ({
    flex: '1 1 auto',
    backgroundImage: `url('${bg}')`,
    backgroundPosition: 'bottom',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    opacity: 0.5,
    maxHeight: 350,
    marginTop: 'auto',
    borderBottomRightRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: theme.shape.borderRadius
}))



/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

export const FavouritesProps: GridProps = {
    //minWidth: `calc(${(100/numberOfColumns).toFixed(5)}% - ${Math.floor(((numberOfColumns - 1) * 16) / numberOfColumns)}px)`,
    //maxWidth: `calc(${(100/numberOfColumns).toFixed(5)}% - ${Math.floor(((numberOfColumns - 1) * 16) / numberOfColumns)}px)`,
    sx: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        '& > .MuiPaper-root': {
            flex: '1 1 auto'
        }
    }
}


/*
 * ---------------------------------------------------------------------------------
 * Components
 * ---------------------------------------------------------------------------------
 */

// export interface IInstitution {
//     id: number;
//     name: string;
// }

// const createInstitutions = (trialTileData: TrialTileData | undefined) => {
//     const institutions: IInstitution[] = [];

//     if (trialTileData) {
//         trialTileData.tileInstitutionData?.forEach((institution) => {
//             if (!!institution.institutionId && !!institution.institutionName)
//             institutions.push({
//                 id: institution.institutionId,
//                 name: institution.institutionName,
//             })
//         })
//     }

//     return institutions;
// }


    // public informationItems?: InformationItem[];
    // public tileMenuItems?: TileMenuItem[];

interface ITileBodyProps {
    trial: ITrial;
    tileInstitutionData: TileInstitutionData | undefined;
    favourite?: boolean;
    expanded: boolean;
    expandedMenuItemsNonFav?: Record<number, boolean> | undefined;
    toggleExpandedMenuItem?: (trialId: number, expandMenuItemId: number) => void | undefined;
    toggleExpandedMenuItemNonfav?: (expandMenuItemId: number) => void | undefined;
    toggleExpanded: Dispatch<SetStateAction<boolean>>;
    toggleFavourite: (id: number) => void;
}

const TileBody: React.FunctionComponent<ITileBodyProps> = ({
    trial,
    tileInstitutionData,
    favourite,
    expanded,
    expandedMenuItemsNonFav,
    toggleExpandedMenuItem,
    toggleExpandedMenuItemNonfav,
    toggleExpanded,
    toggleFavourite,
}) => {

    //const institutions = createInstitutions(trialTileData);
    
    const { data: tileData } = useContext(TileDataContext);

    const [tileInstitution] = useState(() => tileInstitutionData);

    const [tileDataCache, setTileDataCache] = React.useState<Record<string, string> | undefined>(undefined);

    useEffect(() => {
        if (tileData) {
            setTileDataCache(tileData);
            
            // const openNonFav = Object.keys(expandedMenuItemsNonFav ?? {});

            // const openFav = Object.keys(trial.expandedMenuItemStates ?? {});

            // const openMenuItems = [...openNonFav, ...openFav];

            // openMenuItems.forEach((key) => {

            //     const keys = GetKeysForDataObjectsGivenExpandId(key, tileInstitutionData);

            //     setTileDataCache((state) => {
            //         const newState = { ...state };
            //         keys.forEach((key) => {
            //             if (newState[key] === undefined)
            //                 newState[key] = "Error";
            //         });
            //         return newState;
            //     });
            // });

        }
    }, [tileData]);

    return (
    
        <Grid
            {...FavouritesProps}
            item
        >
            <FavouriteTile
            >  
                <TileHeader 
                    trialId={trial.id}
                    trialName={trial.name} 
                    protocolId={trial.protocolId}
                    logoLightUrl={trial.logo?.light}
                    logoDarkUrl={trial.logo?.dark}
                    logoDesktopHeight={trial.logo?.desktopHeight}
                    logoDesktopWidth={trial.logo?.desktopWidth}
                    logoMobileHeight={trial.logo?.mobileHeight}
                    logoMobileWidth={trial.logo?.mobileWidth}
                    favourite={favourite ?? false}
                    expanded={expanded}
                    toggle={favourite ? undefined : () => toggleExpanded(c => !c)}
                    toggleFavourite={toggleFavourite}
                />

                <ListOfContents 
                    tileInstitution={tileInstitution}
                    tileData={tileDataCache}
                    trial={trial}
                    expandedMenuItemsNonFav={expandedMenuItemsNonFav}
                    toggleExpandedMenuItem={toggleExpandedMenuItem}
                    toggleExpandedMenuItemNonfav={toggleExpandedMenuItemNonfav}
                />

                <TileBackground />
            </FavouriteTile>

    </Grid>
    );

    

};

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */
export default TileBody;